import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Card from "../../components/Card/card";
import FilterApplicant from "../../components/FilterApplicant/filterApplicant";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import moment from 'moment';
import {
  faEnvelope,
  faPhone,
  faDollarSign,
  faCalendar,
  faMapMarkerAlt
} from "@fortawesome/fontawesome-free-solid";
import _ from "lodash";

import { ActionCreators } from "../../actions";

import "moment/locale/en-au";

class Home extends Component {
  state = {
    applicants: [],
    count: 0,
    loop: 0,
    currentIndex: 0,
    devider: 10,
    isFiltered: false,
    filter: null,
    location: []
  };

  constructor(props) {
    super(props);
    this.statusProcess = [
      {
        label: "Not Yet Processed",
        bgColor: "#000000"
      },
      {
        label: "Invitation sent",
        bgColor: "#800080"
      },
      {
        label: "Invitation not attended",
        bgColor: "#9acd32"
      },
      {
        label: "Passed",
        bgColor: "#008000"
      },
      {
        label: "Failed",
        bgColor: "#cd5c5c"
      },
      {
        label: "Keep In View",
        bgColor: "#5f9ea0"
      }
    ];

    this.handleClickNum.bind(this);
    this.getLocationName.bind(this);
  }

  componentDidMount() {
    const that = this;
    this.props.jobLocation();
    this.props
      .getApplicantAction(that.state.devider, that.state.currentIndex, that.state.filter)
      .then(data => {
        if (data && data.applicants) {
          that.setState({
            applicants: data.applicants,
            count: data.count,
            loop: Math.ceil(data.count / that.state.devider)
          });
        }

        this.props.vacanciesPLAction().then((v) => {
          that.setState({
            vacanciesPL: v,
          });
        });
      })
      .catch(error => console.error(error));
  }

  getLastOrCurrentCompanySalary(employments) {
    if (employments.length === 0) {
      return "-";
    }

    const currentCompany = _.find(employments, empl => empl.isCurrent === true);
    if (currentCompany !== undefined && currentCompany !== null) {
      return currentCompany.salary.formatMoney(0, "", ".");
    }

    const lastCompany = _.orderBy(employments, empl => empl.periodEnd, [
      "desc"
    ]);
    return lastCompany[0].salary.formatMoney(0, "", ".");
  }

  getLastOrCurrentCompany(employments) {
    if (employments.length === 0) {
      return "unemployed";
    }

    const currentCompany = _.find(employments, empl => empl.isCurrent === true);
    if (currentCompany !== undefined && currentCompany !== null) {
      return currentCompany.companyName;
    }

    const lastCompany = _.orderBy(employments, empl => empl.periodEnd, [
      "desc"
    ]);
    return lastCompany[0].companyName;
  }

  async handleSubmit(vacancyId, title, skills, statusid, locationId) {
    let skillArr = [];
    if(skills.length > 0) _.forEach(skills, s => skillArr.push(s.name));
    const filter = {
      vacancyId: vacancyId,
      title: title,
      skills: skillArr.join(','),
      status: statusid,
      locationId: locationId
    };
    let results = await this.props.getApplicantAction(this.state.devider, 0, filter);
    if(results !== undefined) {
      this.setState({
        applicants: results.applicants,
        count: results.count,
        loop: Math.ceil(results.count / this.state.devider),
        filter: filter,
        currentIndex: 0
      });
    }

    // moving filter to server to make fast
    // let applicants = results.applicants;

    // if (vacancyId != "") {
    //   let applicantFilterByVacancyId = [];

    //   _.forEach(applicants, (applicant, index) => {
    //     let isFind = applicant.vacancyId === vacancyId;

    //     if (isFind) {
    //       applicantFilterByVacancyId.push(applicant);
    //     }
    //   });

    //   applicants = applicantFilterByVacancyId;
    // }

    // if (locationId !== "") {
    //   let applicantFilterBylocationId = [];

    //   _.forEach(applicants, (applicant, index) => {
    //     let isFind = applicant.location === locationId;

    //     if (isFind) {
    //       applicantFilterBylocationId.push(applicant);
    //     }
    //   });

    //   applicants = applicantFilterBylocationId;
    // }

    // if (title !== null) {
    //   let applicantFilterByName = [];

    //   _.forEach(applicants, (applicant, index) => {
    //     let fullname = applicant.firstName + " " + applicant.lastName;
    //     let isFind = _.includes(fullname, title);

    //     if (isFind) {
    //       applicantFilterByName.push(applicant);
    //     }
    //   });

    //   applicants = applicantFilterByName;
    // }

    // if (skills.length > 0) {
    //   let applicantFilterBySkill = [];
    //   _.forEach(applicants, (applicant, index) => {
    //     let isFind = false;

    //     _.forEach(skills, skill => {
    //       if (isFind === false) {
    //         isFind = _.includes(applicant.skills, skill.name);
    //       }
    //     });

    //     if (isFind) {
    //       applicantFilterBySkill.push(applicant);
    //     }
    //   });

    //   applicants = applicantFilterBySkill;
    // }

    // if (statusid !== null) {
    //   let applicantFilterByStatus = [];

    //   _.forEach(applicants, (applicant, index) => {
    //     let isFind = false;

    //     _.forEach(applicant.recruitmentProcesses, (prc, index) => {
    //       if (isFind === false) {
    //         isFind = prc.processStatus === statusid;
    //       }
    //     });

    //     if (isFind) {
    //       applicantFilterByStatus.push(applicant);
    //     }
    //   });

    //   applicants = applicantFilterByStatus;
    // }

    // if (company !== null) {
    //   let applicantFilterByCompany = [];

    //   _.forEach(applicants, (applicant, index) => {
    //     let isFind = false;

    //     _.forEach(applicant.employments, (employment, index) => {
    //       if (isFind === false) {
    //         isFind = _.includes(employment.companyName, company);
    //       }
    //     });

    //     if (isFind) {
    //       applicantFilterByCompany.push(applicant);
    //     }
    //   });

    //   applicants = applicantFilterByCompany;
    // }

    // this.setState({ applicants: applicants, isFiltered: true });
  }

  handleReset(e) {
    const that = this;
    this.props
      .getApplicantAction(that.state.devider, 0, null)
      .then(data => {
        if (data.applicants) {
          that.setState({
            applicants: data.applicants,
            isFiltered: false,
            filter: null,
            count: data.count,
            currentIndex: 0,
            loop: Math.ceil(data.count / that.state.devider),
          });
        }
      })
      .catch(error => console.error(error));
  }

  getCurrentStatusProcess(process) {
    if (
      process !== undefined &&
      process.length > 0 &&
      typeof process === "object"
    ) {
      // const statusNum = process[process.length - 1].processStatus;
      const statusP = _.find(process, p => p.isCurrentMark === true);
      if(statusP !== undefined) {
        return this.statusProcess[statusP.processStatus].label;
      }

      return this.statusProcess[0].label;
    }

    return this.statusProcess[0].label;
  }

  getCurrentStatusColor(process) {
    if (
      process !== undefined &&
      process.length > 0 &&
      typeof process === "object"
    ) {
      // const statusNum = process[process.length - 1].processStatus;
      const statusP = _.find(process, p => p.isCurrentMark === true);
      if(statusP !== undefined) {
        return this.statusProcess[statusP.processStatus].bgColor;
      }

      return this.statusProcess[0].bgColor;
    }

    return this.statusProcess[0].bgColor;
  }

  handleClickNum(num) {
    const that = this;
    this.props
      .getApplicantAction(that.state.devider, num, that.state.filter)
      .then(data => {
        if (data.applicants) {
          that.setState({
            applicants: data.applicants,
            currentIndex: num
          });
        }
      })
      .catch(error => console.error(error));
  }

  getJob(vacancyId) {
    if(this.state.vacanciesPL) {
      const vacancyDetail = this.state.vacanciesPL.find((v) => v.id === vacancyId);
      return vacancyDetail;
    }
    return "";
  }

  getLocationName(locationId) {
    if(locationId === "00000000-0000-0000-0000-000000000000") {
      return "Both";
    }

    if(this.props.jobLocations) {
      const location = this.props.jobLocations.find(l => l.id === locationId);
      return location.location;
    }

    return "-";
  }

  calculateAge(birthday) { // birthday is a date
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970) + " y.o.";
  }

  // ordinal_suffix_of(i) {
  //     var j = i % 10,
  //         k = i % 100;
  //     if (j === 1 && k !== 11) {
  //         return i + "<sup>st</sup>";
  //     }
  //     if (j === 2 && k !== 12) {
  //         return i + "<sup>nd</sup>";
  //     }
  //     if (j === 3 && k !== 13) {
  //         return i + "<sup>rd</sup>";
  //     }
  //     return i + "<sup>th</sup>";
  // }

  render() {
    let len = (this.state.loop);
    let pageNUm = [];
    if(this.state.count > 0) {
      for (let index = 1; index <= len; index++) {
        let cls = ["page-item"]
        if(index === (this.state.currentIndex + 1)) cls.push("active");        
        pageNUm.push(
          <li className={cls.join(' ')} key={index}>            
            <a className="page-link" href="#/" onClick={(e) => this.handleClickNum(index - 1)}>
              {index}
            </a>
          </li>
        )
      }
    }

    return (
      <div>
        <FilterApplicant
          vacancies={this.state.vacanciesPL}
          locations={this.props.jobLocations}
          applicants={this.state.applicants}
          onSubmit={this.handleSubmit.bind(this)}
          onReset={this.handleReset.bind(this)}
        />
        { this.state.count > 0 && this.state.isFiltered===false &&
          <nav aria-label="Page navigation example" style={{ marginLeft: "15px"}}>
            <ul className="pagination">
              <li className={ (this.state.currentIndex > 0) ? "page-item" : "page-item disabled" }>
                <a className="page-link" onClick={(e) => this.handleClickNum(this.state.currentIndex - 1)} href="#/">
                  Previous
                </a>
              </li>
              {pageNUm}
              <li className={ ((this.state.currentIndex + 1) !== this.state.loop) ? "page-item" : "page-item disabled" }>
                <a className="page-link" onClick={(e) => this.handleClickNum(this.state.currentIndex + 1)} href="#/">
                  Next
                </a>
              </li>
            </ul>
          </nav>
        }
        {this.state.applicants.map((applicant, index) => {
          // const company = this.getLastOrCurrentCompany(applicant.employments);
          const companyName = this.getLastOrCurrentCompany(applicant.employments);
          const currentSalary = this.getLastOrCurrentCompanySalary(applicant.employments);
          const statusProcess = this.getCurrentStatusProcess(applicant.recruitmentProcesses);
          const statusColor = this.getCurrentStatusColor(applicant.recruitmentProcesses);
          const job = this.getJob(applicant.vacancyId);
          const preferLocation = this.getLocationName(applicant.location);
          const age = this.calculateAge(new Date(applicant.birthDate));
          return (
            <Card
              id={applicant.id}
              applicant={applicant}
              profilePicture="http://via.placeholder.com/80"
              title={`${applicant.firstName} ${applicant.lastName}`}
              teaser={companyName}
              skill={applicant.skills}
              status={statusProcess}
              statusColor={statusColor}
              expectedSalary={`IDR ${applicant.salary.formatMoney(
                0,
                "",
                "."
              )}`}
              key={index}
            >
              <span className="invisible d-none">{applicant.id}</span>
              <ul className="card-applicant-info">
                <li>
                  <span>Applied As <strong class={job.isPublished?"":"job-unpublished"}>{job.jobTitle}</strong></span>
                </li>
                <li>
                  <span>Applied On <strong>{moment(new Date(applicant.createdOn)).format('llll')}</strong></span>
                </li>
                <li>
                  <span>Prefer Location To <strong>{preferLocation}</strong></span>
                </li>
              </ul>
              <hr />
              <ul className="card-applicant-info">
                <li>
                  <FontAwesomeIcon icon={faCalendar} />
                  <span>{moment(new Date(applicant.birthDate)).format('LL')} (<strong dangerouslySetInnerHTML={{__html: age}}></strong>)</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span>{applicant.email}</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faPhone} />
                  <span>{applicant.phoneNumber}</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <span>{applicant.currentAddress}</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faDollarSign} />
                  <span>
                    IDR {currentSalary}
                  </span>&nbsp;<span className="badge badge-secondary">
                    Current Salary
                  </span>
                </li>
              </ul>
            </Card>
          );
        })}
        { this.state.count > 0 && this.state.isFiltered===false &&
          <nav aria-label="Page navigation example" style={{ marginLeft: "15px"}}>
            <ul className="pagination">
              <li className={ (this.state.currentIndex > 0) ? "page-item" : "page-item disabled" }>
                <a className="page-link" onClick={(e) => this.handleClickNum(this.state.currentIndex - 1)} href="#/">
                  Previous
                </a>
              </li>
              {pageNUm}
              <li className={ ((this.state.currentIndex + 1) !== this.state.loop) ? "page-item" : "page-item disabled" }>
                <a className="page-link" onClick={(e) => this.handleClickNum(this.state.currentIndex + 1)} href="#/">
                  Next
                </a>
              </li>
            </ul>
          </nav>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    jobLocations: state.jobLocations,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));



// WEBPACK FOOTER //
// ./src/pages/auth/home.js